export class ValidName implements ng.IDirective {
  public restrict = "A";
  public require = "ngModel";

  public link = (scope: any, element: any, attrs: any, ngModelCtrl: any) => {
    $(() => {
        ngModelCtrl.$validators.validName = (modelValue, viewValue): boolean => {
            if (modelValue == null || modelValue == '') return true;
          const regExp = RegExp("^(?!\\.+$)(?!-+$)[\\p{L}\\p{Mn}\\p{Pd}'.,\\s]+$", "gmu");
          return regExp.test(modelValue);
        };
    });
  }
}

